export const NavigationUrls = {
    COMPLETE_PROFILE_URL: '/complete-profile',
    ACCEPTED_BIDS_URL: '/accepted-bids',
    PROFILE_URL: '/profile',
    REQUEST_DETAILS_URL: `/requests/:requestId/details`,
    REQUESTS_BY_MARKET: `/open-requests/:market/:category`,
    ACCEPTED_BID_DETAILS_URL: `/requests/:requestId/accepted/details`,
    PLACE_BID_URL: `/requests/:requestId/place-bid/`,
    ACTIVE_SUBSCRIPTION: `/active-subscription`,
    IN_ACTIVE_SUBSCRIPTION: `/inactive-subscription`,
    ADD_SUBSCRIPTION: `/add-subscription`,
    ADD_SUBSCRIPTION_WITH_PLAN: `/add-subscription/:planID`,
    BUSINESS_CHECKOUT: `/business/checkout/:planID`,
    OPEN_REQUESTS: `/open-requests`,
    PENDING_COMMISSION_PAYMENTS: `/pending-commission-payments`,
    INVOICES: `/invoices`,
    SERVICE_AREA: `/service-area`,
    PREFERENCES: `/preferences`,
    REQUEST_DETAILS_URL_RESTRICTED: `/request-access/:requestToken`,
    SERVICES: `/services`,
    TERMS_OF_SERVICE: `/agreement/:category`,
    PAYMENT_METHOD: `/payment-methods`,
    WORKING_SCHEDULES: `/working-schedules`,
    CREATE_CUSTOMER_REQUEST: `/customer/request/create`,
    CUSTOMER_REQUEST_FORM : `/customer/request/form/:token`,
    CUSTOMER_REQUESTS_LIST : `/customer/requests`,
    CUSTOMER_REQUEST_INVOICE: `/customer/request/:scRequestID/invoice`,
    INVOICE_SETTINGS: `/invoice/settings`,
    SELLER_DRIVER: `/seller/driver`,
    INVITE_SELLER_DRIVER: `/seller/driver/invite`,
    DRIVER_INVITE_ACCEPTANCE: `/driver/invite/acceptance`,
}